const scopes = {
  ver: false,
  crear: false,
  editar: false,
  eliminar: false,
};

export default [
  {
    rol: 'Configuración',
    scopes: { ...scopes },
  },
  {
    rol: 'Planeación',
    scopes: { ...scopes },
  },
  {
    rol: 'Presupuestos',
    scopes: { ...scopes },
  },
  {
    rol: 'Programación',
    scopes: { ...scopes },
  },
  {
    rol: 'Licitaciones',
    scopes: { ...scopes },
  },
  {
    rol: 'Adjudicaciones',
    scopes: { ...scopes },
  },
  {
    rol: 'Contratos',
    scopes: { ...scopes },
  },
  {
    rol: 'Supervisión',
    scopes: { ...scopes },
  },
  {
    rol: 'Estimaciones',
    scopes: { ...scopes },
  },
  {
    rol: 'Consultas',
    scopes: { ...scopes },
  },
  {
    rol: 'Pagos',
    scopes: { ...scopes },
  },
  {
    rol: 'Seguridad',
    scopes: { ...scopes },
  },
  {
    rol: 'Catálogos',
    scopes: { ...scopes },
  },
  {
    rol: 'Auditorías',
    scopes: {
      ...scopes, registro: false, seguimiento: false,
    },
  },
];
